import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from 'primeng/inputtext';
import * as i4 from 'primeng/dropdown';
import * as i5 from 'primeng/inputnumber';
import * as i6 from 'primeng/table';
import * as i7 from 'primeng/api';
import * as i8 from 'primeng/radiobutton';
import * as i9 from 'primeng/tooltip';
import * as i10 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class USCompanyAdditionalDetailsLibraryService {
    constructor() { }
}
USCompanyAdditionalDetailsLibraryService.ɵfac = function USCompanyAdditionalDetailsLibraryService_Factory(t) { return new (t || USCompanyAdditionalDetailsLibraryService)(); };
USCompanyAdditionalDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: USCompanyAdditionalDetailsLibraryService, factory: USCompanyAdditionalDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(USCompanyAdditionalDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "mr-3": a0 }; };
function USCompanyAdditionalDetailsLibraryComponent_p_radioButton_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-radioButton", 25);
} if (rf & 2) {
    const compOwnType_r12 = ctx.$implicit;
    const i_r13 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, i_r13 < ctx_r0.companyTypList.length - 1))("value", compOwnType_r12.code)("label", compOwnType_r12.name);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_9_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.USCompanyAdditionalDetails.get("compOwnTypeCode").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_15_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_15_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.USCompanyAdditionalDetails.get("firstName").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_20_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_20_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.USCompanyAdditionalDetails.get("lastName").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_30_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_30_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.USCompanyAdditionalDetails.get("nationality").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_35_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_35_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.USCompanyAdditionalDetails.get("immigrationStatusId").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_small_40_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_small_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 26);
    i0.ɵɵtemplate(1, USCompanyAdditionalDetailsLibraryComponent_small_40_span_1_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.USCompanyAdditionalDetails.get("immigrationStatusId").errors["required"]);
} }
function USCompanyAdditionalDetailsLibraryComponent_button_43_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function USCompanyAdditionalDetailsLibraryComponent_button_43_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.addUSCompanyAdditionalDetails(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.USCompanyAdditionalDetails.get("id").value ? "SAVE" : "ADD");
} }
function USCompanyAdditionalDetailsLibraryComponent_button_44_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function USCompanyAdditionalDetailsLibraryComponent_button_44_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onResetUSCompanyAdditionalDetails(); });
    i0.ɵɵtext(1, "CANCEL");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_ng_template_52_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 30);
    i0.ɵɵtext(1, "Action");
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_ng_template_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 30);
    i0.ɵɵtext(2, "Type of Investor");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 30);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 30);
    i0.ɵɵtext(6, "Nationality");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 30);
    i0.ɵɵtext(8, "Immigration Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 30);
    i0.ɵɵtext(10, "Percent of Ownership");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, USCompanyAdditionalDetailsLibraryComponent_ng_template_52_th_11_Template, 2, 0, "th", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", !ctx_r9.disabledControls);
} }
function USCompanyAdditionalDetailsLibraryComponent_ng_template_53_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "button", 33);
    i0.ɵɵlistener("click", function USCompanyAdditionalDetailsLibraryComponent_ng_template_53_td_11_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r29); const USCompanyAdditionalDetail_r25 = i0.ɵɵnextContext().$implicit; const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.onEditUSCompanyAdditionalDetail(USCompanyAdditionalDetail_r25); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 34);
    i0.ɵɵlistener("click", function USCompanyAdditionalDetailsLibraryComponent_ng_template_53_td_11_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r29); const USCompanyAdditionalDetail_r25 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.onDeleteUSCompanyAdditionalDetail(USCompanyAdditionalDetail_r25); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function USCompanyAdditionalDetailsLibraryComponent_ng_template_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, USCompanyAdditionalDetailsLibraryComponent_ng_template_53_td_11_Template, 4, 0, "td", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const USCompanyAdditionalDetail_r25 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r25.compOwnTypeName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r25.firstName + " " + USCompanyAdditionalDetail_r25.lastName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r25.nationalityName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r25.immigrationStatusName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r25.ownershipPercent + "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.disabledControls);
} }
function USCompanyAdditionalDetailsLibraryComponent_ng_template_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "No U.S company additional details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class USCompanyAdditionalDetailsLibraryComponent {
    constructor() {
        this.initialRefLibrary = {
            code: null,
            desc: null,
            group: null,
            id: null,
            name: 'Select'
        };
        this.USCompanyAdditionalDetailsSubmited = false;
        this.resetForm = {
            id: null,
            companyId: null,
            compOwnTypeCode: null,
            compOwnTypeId: null,
            firstName: null,
            lastName: null,
            middleName: null,
            nationality: null,
            immigrationStatusCode: null,
            immigrationStatusId: null,
            ownershipPercent: null
        };
        this.USCompanyAdditionalDetailsArray = [];
        this.initialCountry = {
            countryCode: null,
            countryName: 'Select',
            createdBy: null,
            modifiedBy: null,
            phoneCode: null,
            sequenceNumber: null,
            shortCountryCode: null
        };
    }
    ngOnInit() {
        this.USCompanyAdditionalDetails = new FormGroup({
            id: new FormControl(null),
            companyId: new FormControl(null),
            compOwnTypeCode: new FormControl(null, Validators.required),
            compOwnTypeId: new FormControl(null),
            firstName: new FormControl(null, Validators.required),
            lastName: new FormControl(null, Validators.required),
            middleName: new FormControl(null),
            nationality: new FormControl(null, Validators.required),
            immigrationStatusCode: new FormControl(null),
            immigrationStatusId: new FormControl(null, Validators.required),
            ownershipPercent: new FormControl(null, Validators.required)
        });
    }
    addUSCompanyAdditionalDetails() {
        this.USCompanyAdditionalDetailsSubmited = true;
        const group = this.USCompanyAdditionalDetails;
        if (group.value.compOwnTypeCode && group.value.nationality &&
            group.value.immigrationStatusId &&
            (group.value.firstName && group.value.firstName.trim() !== '') &&
            (group.value.lastName && group.value.lastName.trim() !== '') &&
            group.value.ownershipPercent !== null) {
            const payload = {
                compOwnTypeCode: group.value.compOwnTypeCode,
                compOwnTypeId: null,
                companyId: this.primaryData.companyId,
                firstName: group.value.firstName,
                id: group.value.id ? group.value.id : null,
                immigrationStatusCode: null,
                immigrationStatusId: group.value.immigrationStatusId,
                lastName: group.value.lastName,
                middleName: group.value.middleName,
                nationality: group.value.nationality,
                ownershipPercent: group.value.ownershipPercent
            };
            // this.apiEnterEntitiesRelationshipDetailsLibraryService.onSaveUSCompanyAdditionalDetails(payload, this.primaryData)
            //   .pipe(
            //     take(1),
            //     mergeMap(response => {
            //       if (response) {
            //         if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            //           this.updateStepStatus('INPROGRESS');
            //         }
            //         this.onResetUSCompanyAdditionalDetails();
            //         return this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetUSCompanyAdditionalDetails(this.primaryData);
            //       } else {
            //         return EMPTY;
            //       }
            //     })
            //   )
            //   .subscribe(responseUSCompanyAdditionalDetails => {
            //     this.setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails);
            //   });
        }
    }
    onResetUSCompanyAdditionalDetails() {
        this.USCompanyAdditionalDetailsSubmited = false;
        this.resetForm = {
            id: null,
            companyId: null,
            compOwnTypeCode: null,
            compOwnTypeId: null,
            firstName: null,
            lastName: null,
            middleName: null,
            nationality: null,
            immigrationStatusCode: null,
            immigrationStatusId: null,
            ownershipPercent: null
        };
        this.USCompanyAdditionalDetails.reset(Object.assign({}, this.resetForm));
    }
    onEditUSCompanyAdditionalDetail(USCompanyAdditionalDetail) {
        this.USCompanyAdditionalDetails.reset({
            id: USCompanyAdditionalDetail.id,
            companyId: USCompanyAdditionalDetail.companyId,
            compOwnTypeCode: USCompanyAdditionalDetail.compOwnTypeCode,
            compOwnTypeId: USCompanyAdditionalDetail.compOwnTypeId,
            firstName: USCompanyAdditionalDetail.firstName,
            lastName: USCompanyAdditionalDetail.lastName,
            middleName: USCompanyAdditionalDetail.middleName,
            nationality: USCompanyAdditionalDetail.nationality,
            immigrationStatusCode: USCompanyAdditionalDetail.immigrationStatusCode,
            immigrationStatusId: USCompanyAdditionalDetail.immigrationStatusId,
            ownershipPercent: USCompanyAdditionalDetail.ownershipPercent
        });
    }
    onDeleteUSCompanyAdditionalDetail(USCompanyAdditionalDetail) {
        // this.apiEnterEntitiesRelationshipDetailsLibraryService
        //   .onDeleteUSCompanyAdditionalDetails(USCompanyAdditionalDetail.id, this.primaryData)
        //   .pipe(
        //     take(1),
        //     mergeMap(response => {
        //       if (response) {
        //         return this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetUSCompanyAdditionalDetails(this.primaryData);
        //       } else {
        //         return EMPTY;
        //       }
        //     })
        //   )
        //   .subscribe(responseUSCompanyAdditionalDetails => {
        //     this.setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails);
        //   });
    }
}
USCompanyAdditionalDetailsLibraryComponent.ɵfac = function USCompanyAdditionalDetailsLibraryComponent_Factory(t) { return new (t || USCompanyAdditionalDetailsLibraryComponent)(); };
USCompanyAdditionalDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: USCompanyAdditionalDetailsLibraryComponent, selectors: [["lib-us-company-additional-details-library"]], decls: 55, vars: 16, consts: [[1, "mt-2", "mb-4", 3, "formGroup"], ["formGroupName", "detailsForm"], [1, "row", "mb-3"], [1, "col-12"], [1, "greencard-pwd-sub-header"], ["formControlName", "compOwnTypeCode", "name", "compOwnTypeCode", 3, "ngClass", "value", "label", 4, "ngFor", "ngForOf"], ["class", "p-error", 4, "ngIf"], [1, "row"], [1, "form-group", "col-3"], [1, "p-label", "required"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "firstName", 1, "p-form-control"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "lastName", 1, "p-form-control"], [1, "p-label"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "middleName", 1, "p-form-control"], ["placeholder", "Select", "optionValue", "countryCode", "optionLabel", "countryName", "formControlName", "nationality", 1, "p-form-control", 3, "options"], ["placeholder", "Select", "optionValue", "id", "optionLabel", "name", "formControlName", "immigrationStatusId", 1, "p-form-control", 3, "options"], ["formControlName", "ownershipPercent", "placeholder", "Enter", "suffix", "%", 1, "p-form-control", 3, "min", "max"], [1, "row", "mb-4"], ["type", "button", "class", "p-btn btn btn-primary mr-3", 3, "click", 4, "ngIf"], ["type", "button", "class", "p-btn btn btn-light", 3, "click", 4, "ngIf"], [1, "p-label", "p-label-blue", "p-label-bold"], ["tableStyleClass", "visa-table", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], [3, "ngIf"], ["formControlName", "compOwnTypeCode", "name", "compOwnTypeCode", 3, "ngClass", "value", "label"], [1, "p-error"], [4, "ngIf"], ["type", "button", 1, "p-btn", "btn", "btn-primary", "mr-3", 3, "click"], ["type", "button", 1, "p-btn", "btn", "btn-light", 3, "click"], ["scope", "col"], ["scope", "col", 4, "ngIf"], [1, "subtask-form-header-buttons-holder"], ["type", "button", "pTooltip", "Edit", "pButton", "", "icon", "pi pi-pencil", 1, "p-button-text", "p-button-rounded", "mr-3", 3, "click"], ["type", "button", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "click"], [1, "visa-row-nodata"]], template: function USCompanyAdditionalDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h6", 4);
        i0.ɵɵtext(5, "U.S company additional details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵtemplate(8, USCompanyAdditionalDetailsLibraryComponent_p_radioButton_8_Template, 1, 5, "p-radioButton", 5);
        i0.ɵɵtemplate(9, USCompanyAdditionalDetailsLibraryComponent_small_9_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "label", 9);
        i0.ɵɵtext(13, "First Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "input", 10);
        i0.ɵɵtemplate(15, USCompanyAdditionalDetailsLibraryComponent_small_15_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 8);
        i0.ɵɵelementStart(17, "label", 9);
        i0.ɵɵtext(18, "Last Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "input", 11);
        i0.ɵɵtemplate(20, USCompanyAdditionalDetailsLibraryComponent_small_20_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 8);
        i0.ɵɵelementStart(22, "label", 12);
        i0.ɵɵtext(23, "Middle Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "input", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 2);
        i0.ɵɵelementStart(26, "div", 8);
        i0.ɵɵelementStart(27, "label", 9);
        i0.ɵɵtext(28, "Nationality");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(29, "p-dropdown", 14);
        i0.ɵɵtemplate(30, USCompanyAdditionalDetailsLibraryComponent_small_30_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 8);
        i0.ɵɵelementStart(32, "label", 9);
        i0.ɵɵtext(33, "Immigration Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(34, "p-dropdown", 15);
        i0.ɵɵtemplate(35, USCompanyAdditionalDetailsLibraryComponent_small_35_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 8);
        i0.ɵɵelementStart(37, "label", 9);
        i0.ɵɵtext(38, "Percent of ownership");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(39, "p-inputNumber", 16);
        i0.ɵɵtemplate(40, USCompanyAdditionalDetailsLibraryComponent_small_40_Template, 2, 1, "small", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 17);
        i0.ɵɵelementStart(42, "div", 3);
        i0.ɵɵtemplate(43, USCompanyAdditionalDetailsLibraryComponent_button_43_Template, 2, 1, "button", 18);
        i0.ɵɵtemplate(44, USCompanyAdditionalDetailsLibraryComponent_button_44_Template, 2, 0, "button", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 2);
        i0.ɵɵelementStart(46, "div", 3);
        i0.ɵɵelementStart(47, "label", 20);
        i0.ɵɵtext(48, "Added U.S company additional details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 2);
        i0.ɵɵelementStart(50, "div", 3);
        i0.ɵɵelementStart(51, "p-table", 21);
        i0.ɵɵtemplate(52, USCompanyAdditionalDetailsLibraryComponent_ng_template_52_Template, 12, 1, "ng-template", 22);
        i0.ɵɵtemplate(53, USCompanyAdditionalDetailsLibraryComponent_ng_template_53_Template, 12, 6, "ng-template", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(54, USCompanyAdditionalDetailsLibraryComponent_ng_template_54_Template, 3, 0, "ng-template", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.USCompanyAdditionalDetails);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.companyTypList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("compOwnTypeCode").valid && ctx.USCompanyAdditionalDetails.get("compOwnTypeCode").touched && ctx.USCompanyAdditionalDetails.get("compOwnTypeCode").errors);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("firstName").valid && ctx.USCompanyAdditionalDetails.get("firstName").touched && ctx.USCompanyAdditionalDetails.get("firstName").errors);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("lastName").valid && ctx.USCompanyAdditionalDetails.get("lastName").touched && ctx.USCompanyAdditionalDetails.get("lastName").errors);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("options", ctx.nationalityList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("nationality").valid && ctx.USCompanyAdditionalDetails.get("nationality").touched && ctx.USCompanyAdditionalDetails.get("nationality").errors);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.immigrationStatusList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("immigrationStatusId").valid && ctx.USCompanyAdditionalDetails.get("immigrationStatusId").touched && ctx.USCompanyAdditionalDetails.get("immigrationStatusId").errors);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("min", 0)("max", 100);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.USCompanyAdditionalDetails.get("immigrationStatusId").valid && ctx.USCompanyAdditionalDetails.get("immigrationStatusId").touched && ctx.USCompanyAdditionalDetails.get("immigrationStatusId").errors);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("value", ctx.USCompanyAdditionalDetailsArray);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.USCompanyAdditionalDetailsArray.length === 0);
    } }, directives: [i1.ɵangular_packages_forms_forms_ba, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormGroupName, i2.NgForOf, i2.NgIf, i1.DefaultValueAccessor, i3.InputText, i1.NgControlStatus, i1.FormControlName, i4.Dropdown, i5.InputNumber, i6.Table, i7.PrimeTemplate, i8.RadioButton, i2.NgClass, i9.Tooltip, i10.ButtonDirective], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(USCompanyAdditionalDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-us-company-additional-details-library',
                templateUrl: './us-company-additional-details-library.component.html',
                styleUrls: ['./us-company-additional-details-library.component.scss']
            }]
    }], function () { return []; }, null); })();

class USCompanyAdditionalDetailsLibraryModule {
}
USCompanyAdditionalDetailsLibraryModule.ɵfac = function USCompanyAdditionalDetailsLibraryModule_Factory(t) { return new (t || USCompanyAdditionalDetailsLibraryModule)(); };
USCompanyAdditionalDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: USCompanyAdditionalDetailsLibraryModule });
USCompanyAdditionalDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(USCompanyAdditionalDetailsLibraryModule, { declarations: [USCompanyAdditionalDetailsLibraryComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule], exports: [USCompanyAdditionalDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(USCompanyAdditionalDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [USCompanyAdditionalDetailsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule
                ],
                exports: [USCompanyAdditionalDetailsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of us-company-additional-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { USCompanyAdditionalDetailsLibraryComponent, USCompanyAdditionalDetailsLibraryModule, USCompanyAdditionalDetailsLibraryService };
//# sourceMappingURL=us-company-additional-details-library.js.map
